var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"v-window-item",attrs:{"fluid":""}},[(_vm.loading)?_c('v-overlay',{attrs:{"absolute":"","color":"white","opacity":"0.7"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }